import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';

//Import Icons
import FeatherIcon from 'feather-icons-react';

// import images
import americanEx from '../../assets/images/payments/american-ex.png';
import discover from '../../assets/images/payments/discover.png';
import masterCard from '../../assets/images/payments/master-card.png';
import paypal from '../../assets/images/payments/paypal.png';
import visa from '../../assets/images/payments/visa.png';

//Import Images
import logolight from '../../assets/images/Finallogolight1-3.png';
import logodark from '../../assets/images/Finallog1-2.png';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grid1: [
        { title: 'Home', link: '/' },
        { title: 'About', link: '/about' },
        { title: 'Contact', link: '/contact' },
        { title: 'FAQ', link: '/faq' },
        // { title: 'Guide', link: '/helpcenter-guides' },
      ],
      grid2: [
        { title: 'Terms of Services', link: '/terms-and-conditions' },
        { title: 'Privacy Policy', link: '/privacy-policy' },
        // { title: 'Invoice Search', link: '/invoice-search' },
      ],
      paymentCardData: [
        { img: americanEx, title: 'American Express' },
        { img: discover, title: 'Discover' },
        { img: masterCard, title: 'Master Card' },
        { img: paypal, title: 'Paypal' },
        { img: visa, title: 'Visa' },
      ],
      socialLinks: [
        { icon: 'facebook', href: '#' },
        { icon: 'instagram', href: '#' },
        { icon: 'twitter', href: '#' },
        { icon: 'linkedin', href: '#' },
      ],
    };
  }

  render() {
    const { isLight, isBorderLine } = this.props;

    return (
      <React.Fragment>
        <footer className="footer">
          <Container>
            <Row>
              <Col className="col-12">
                <div className={isBorderLine ? 'footer-py-60 footer-border' : 'footer-py-60'}>
                  <Row>

                    {/* Brand Column */}
                    <Col lg={5} className="col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                      <Link to="/" className="logo-footer">
                        <img
                          src={isLight ? logodark : logolight}
                          alt="DigitCard"
                        />
                      </Link>

                      <p className={`footer-desc ${isLight ? 'text-muted' : 'text-foot'} mt-3 mb-0`}>
                        DigitCard app that lets you easily manage and organize your items in one place, keeping everything accessible, secure, and paper-free.
                      </p>

                      {/* Social Icons */}
                      {/* <ul className={`list-unstyled ${isLight ? 'social-icon social' : 'social-icon foot-social-icon'} mb-0 mt-4 d-flex flex-wrap gap-2`}>
                        {this.state.socialLinks.map((social, key) => (
                          <li key={key} className="list-inline-item">
                            <Link to={social.href} className="rounded">
                              <FeatherIcon
                                icon={social.icon}
                                className="fea icon-sm fea-social"
                              />
                            </Link>
                          </li>
                        ))}
                      </ul> */}
                    </Col>

                    {/* Companies Column */}
                    <Col lg={3} md={4} className="col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                      <h5 className={isLight ? 'text-dark footer-head' : 'text-light footer-head'}>
                        Companies
                      </h5>
                      <div
                        style={{
                          width: '30px',
                          height: '2px',
                          backgroundColor: '#6f42c1',
                          borderRadius: '2px',
                          marginTop: '10px',
                          marginBottom: '18px',
                        }}
                      />
                      <ul className="list-unstyled footer-list mb-0">
                        {this.state.grid1.map((grid, key) => (
                          <li key={key}>
                            <Link
                              to={grid.link}
                              className={isLight ? 'text-muted' : 'text-foot'}
                            >
                              <i className="uil uil-angle-right-b me-1"></i>
                              {grid.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </Col>

                    {/* Policies Column */}
                    <Col lg={4} md={4} className="col-12 mt-4 mt-lg-0 pt-2 pt-lg-0">
                      <h5 className={isLight ? 'text-dark footer-head' : 'text-light footer-head'}>
                        Policies
                      </h5>
                      <div
                        style={{
                          width: '30px',
                          height: '2px',
                          backgroundColor: '#6f42c1',
                          borderRadius: '2px',
                          marginTop: '10px',
                          marginBottom: '18px',
                        }}
                      />
                      <ul className="list-unstyled footer-list mb-0">
                        {this.state.grid2.map((grid, key) => (
                          <li key={key}>
                            <Link
                              to={grid.link}
                              className={isLight ? 'text-muted' : 'text-foot'}
                            >
                              <i className="uil uil-angle-right-b me-1"></i>
                              {grid.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </Col>

                  </Row>
                </div>
              </Col>
            </Row>
          </Container>

          {/* Bottom Bar */}
          <div className="footer-py-30 footer-bar">
            <Container>
              <Row className="align-items-center">
                <Col sm={6}>
                  <div className="text-sm-start">
                    <p className="mb-0 text-foot">
                      © {new Date().getFullYear()}{' '}
                      <strong style={{ color: '#fff' }}>DigitCard</strong>. All rights reserved.
                    </p>
                  </div>
                </Col>

                {/* <Col sm={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <ul className="list-unstyled text-sm-end mb-0 d-flex gap-1 flex-wrap justify-content-sm-end">
                    {this.state.paymentCardData.map((item, key) => (
                      <li className="list-inline-item" key={key}>
                        <Link to="#">
                          <img
                            src={item.img}
                            className="avatar avatar-ex-sm"
                            title={item.title}
                            alt={item.title}
                          />
                        </Link>
                      </li>
                    ))}
                  </ul>
                </Col> */}
              </Row>
            </Container>
          </div>

        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
